<template>
  <dd-card class="slim-card">
    <div class="flex-row justify-content-between gap-lg">

      <div class="flex-row gap-lg">
        <dd-multi-switch group-name="automation_category" :value="selectedSortingCategory" @input="setSelectedSortingCategory">
          <dd-multi-switch-item title="Actief" :value="OverviewSortOptionEnum.ACTIVE" active/>
          <dd-multi-switch-item title="Eenmalig" :value="OverviewSortOptionEnum.ONCE"/>
          <dd-multi-switch-item title="Inactief" :value="OverviewSortOptionEnum.INACTIVE"/>
        </dd-multi-switch>

        <div class="flex-row gap-lg align-items-center">
          <div class="flex-row align-center gap-xxs">
            <div class="icon-wrapper" >
              <EmailFastIcon :class="iconClass"/>
            </div>
            <dd-switch :value="showEmailAutomations" @input="(checked) => setShowEmailAutomations(checked)"></dd-switch>
            <p class="m-0" style="align-self: center">E-mail</p>
          </div>
          <div class="flex-row align-center gap-xxs">
            <div class="icon-wrapper">
              <BellIcon :class="iconClass"/>
            </div>
            <dd-switch :value="showSignalAutomations" @input="(checked) => setShowSignalAutomations(checked)"></dd-switch>
            <p class="m-0" style="align-self: center">Signaal</p>
          </div>
          <div class="flex-row align-center gap-xxs">
            <div class="icon-wrapper">
              <CheckboxOutlineIcon :class="iconClass"/>
            </div>
            <dd-switch :value="showTaskAutomations" @input="(checked) => setShowTaskAutomations(checked)"></dd-switch>
            <p class="m-0" style="align-self: center">Taak</p>
          </div>
        </div>
      </div>

      <div style="position: relative; flex: 1; min-width: 200px; max-width: 350px">
        <dd-input
            placeholder="Zoeken..."
            class="search-input"
            :value="searchQuery"
            @input="setSearchQuery"
        />
        <MagnifyIcon title="" class="icon-size-lg fill-primary search-icon"/>
      </div>
    </div>
  </dd-card>
</template>

<script>
import {OverviewSortOptionEnum} from "~/pages/automation/enums";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "AutomationSortingComponent",
  methods:{
    ...mapActions('$_automation', {
      setSelectedSortingCategory: 'setSelectedSortingCategory',
      setShowEmailAutomations: 'setShowEmailAutomations',
      setShowSignalAutomations: 'setShowSignalAutomations',
      setShowTaskAutomations: 'setShowTaskAutomations',
      setSearchQuery: 'setSearchQuery',
    })
  },
  computed: {
    ...mapGetters('$_automation', {
      searchQuery: 'searchQuery',
      selectedSortingCategory: 'selectedSortingCategory',
      showEmailAutomations: 'showEmailAutomations',
      showSignalAutomations: 'showSignalAutomations',
      showTaskAutomations: 'showTaskAutomations',
    }),
    OverviewSortOptionEnum() {
      return OverviewSortOptionEnum;
    },
    iconClass () {
      return 'icon-size-md'
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/_default.scss';

.icon-wrapper {
  width: $spacing-xl;
  border-radius: $border-radius-base;
  background-color: $main-content-bg-color;
  height: $spacing-xl;
  align-self: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  span {
    color: $brand-primary;
    fill: $brand-primary;
    margin-top: -4px;
  }
}
.search-icon {
  position:absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-53%);
}
</style>
<style>
.search-input {
  width: 100%;
  input {
    padding-right: 35px !important;
  }
}
</style>